/**
 * selectNextQuestion.js
 * Written by: Brian Kim
 */
import selectedQuizRaw from '../../../quiz/selectors/selectedQuiz';


export const SELECT_NEXT_QUESTION_START = `SELECT_NEXT_QUESTION_START`;
export const SELECT_NEXT_QUESTION_SUCCESS = `SELECT_NEXT_QUESTION_SUCCESS`;
export const SELECT_NEXT_QUESTION_FAILURE = `SELECT_NEXT_QUESTION_FAILURE`;

export const selectNextQuestionStart = (id) => ({
  type: SELECT_NEXT_QUESTION_START,
  id,
});

export const selectNextQuestionSuccess = (id) => ({
  type: SELECT_NEXT_QUESTION_SUCCESS,
  id,
});

export const selectNextQuestionFailure = () => ({
  type: SELECT_NEXT_QUESTION_FAILURE,
});

/**
 * Description of the selectNextQuestion action
 */

export const selectNextQuestion = (id) => {
  return (dispatch, getState) => {
    dispatch(selectNextQuestionStart(id));
    return new Promise((resolve) => {
      const quiz = selectedQuizRaw(getState());
      if (!id || !quiz || !quiz.questions || quiz.questions.length === 0) {
        dispatch(selectNextQuestionFailure());
        resolve();
      }
      const { questions } = quiz;
      const currentIndex = questions.indexOf(parseInt(id, 10));

      // Return next element if it exists or first array element
      const nextIndex = !questions[currentIndex + 1] ? 0 : currentIndex + 1;
      dispatch(selectNextQuestionSuccess(questions[nextIndex]));
      resolve(questions[nextIndex]);
    });
  };
};
